import Vue from "vue";
import App from "./App.vue";
import plugins from "@/plugins";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/filters";
import i18next from "i18next";

Vue.config.productionTip = false;

const i18n = new plugins.vueI18Next(i18next);

new Vue({
  ...plugins,
  i18n,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
